@let withCallWaiterMain = this.withCallWaiterMain();
@let withCallWaiterRequestBill = this.withCallWaiterRequestBill();

<app-page-header
  class="header"
  [backSwipe]="backSwipeConfig"
  [tableName]="table()?.tableName"
  [backButtonRouterLink]="['/main', 'home']"
/>

<div class="content">
  <div class="title">
    <span class="big">Service Centre</span>
    <span class="title__text">Everything you need at your fingertips.<br>Request service, view your bill, and control your dining experience<br>- all from your table.</span>
  </div>


  <div class="call__buttons">

    @if (withCallWaiterMain) {
      <app-button-call-waiter-main
        class="call-waiter"
        coreActivitySection="CallWaiter"
        [coreUserActivityClickTracking]="callWaiterService.getTrackingName('main', callWaiterMain())"
      />
    }

    @if (withCallWaiterRequestBill) {
      <app-button-call-waiter-bill
        class="call-waiter"
        coreActivitySection="CallWaiter"
        [coreUserActivityClickTracking]="callWaiterService.getTrackingName('secondary', collWaiterRequestBill())"
      />
    }

  </div>

  <app-service-center-amenities class="amenities"/>
</div>

